import * as Yup from "yup";
export const formikAddPdfForm = {
    initialValues: {
        formTitle : "",
        applicationTypeId : "",
        documentTypeId : "",
        state : {},
        signer : [],
        pdfForm : {},
        stateId : "",
        isSignatureReq : false
    },
    validationSchema: Yup.object({
        formTitle: Yup.string().required("Required Field"),
        applicationTypeId: Yup.string().required("Required Field"),
        stateId: Yup.string().required("Required Field")
    })
};

export const formikEditPdfForm = {
    initialValues: {
        formTitle : "",
        applicationTypeId : "",
        documentTypeId : "",
        state : {},
        signer : [],
        pdfForm : {},
        stateId : "",
        isSignatureReq : false
    }
};

export const ImportApplicationtypeFormik = {
    initialValues: {
        selectedApplicationType : []
    }
};


export const formikAddApplicationType = {
    initialValues: {
        applicationTitle : "",
        applicationStages : []
    },
    validationSchema: Yup.object({
        applicationTitle: Yup.string().required("Required Field"),
        applicationStages: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required('Stage name is required'),
        child: Yup.array()
          .of(
            Yup.object().shape({
              name: Yup.string().required('Child stage name is required')
            })
          )
      })
    )
    })
};

export const formikAddDocumentType = {
    initialValues: {
        documentTitle : "",
        applicableStates : []
    },
    validationSchema: Yup.object({
        documentTitle: Yup.string().required("Required Field"),
        applicableStates: Yup.array().min(1, "").required("Required Field")
    })
};

export const formikAddSigner = {
    initialValues: {
        signer : ""
    },
    validationSchema: Yup.object({
        signer: Yup.string().required("Required Field")
    })
};

export const formikAddWorkflow = {
    initialValues: {
        workflowTitle : "",
        state : {},
        stateId : "",
        applicationTypeId : "",
        pdfFormIds : [],
        signStage : "",
        signStageLast : "",
        signChildStage : "",
        documentType : [],
        docStage : "",
        isSignStageRequired : false
    }
};
